import { render } from "./CceGroupsEditing.vue?vue&type=template&id=53cba5dd&ts=true"
import script from "./CceGroupsEditing.vue?vue&type=script&lang=ts"
export * from "./CceGroupsEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__